import api from "./axios.service";
import { getQueryStringFromObject } from "./common.service";
const axios = api;

async function getArtists(query = {}) {
    try {
        let queryString = await getQueryStringFromObject(query);
        if (queryString) {
            queryString = '?' + queryString;
        } else {
            queryString = '';
        }
        let response = await axios.get('/artists' + queryString);
        return response.data;
    } catch (error) {
        console.error(error);
    }
}


async function insertArtist(artistData) {
    try {
        let response = await axios.post('/artists', artistData);
        return response.data;
    } catch (error) {
        console.error(error);
    }
}


export {
    getArtists,
    insertArtist
}
